
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function FeaturedCaseStudy() {
  const { ref: sectionRef, isVisible: sectionVisible } = useScrollAnimation();
  const { ref: imageRef, isVisible: imageVisible } = useScrollAnimation();
  const { ref: contentRef, isVisible: contentVisible } = useScrollAnimation();

  return (
    <section ref={sectionRef} className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className={`text-center mb-16 transition-all duration-700 ${
          sectionVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <span className="inline-block px-4 py-1.5 bg-[#00989e]/10 text-[#00989e] text-sm font-medium rounded-full mb-4">
            Featured Project
          </span>
          <h2 className="font-['Montserrat'] text-3xl md:text-4xl font-bold text-slate-900">
            Our Most Impactful Campaign
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div
            ref={imageRef}
            className={`relative transition-all duration-1000 ${
              imageVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
            }`}
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl transform -rotate-2 hover:rotate-0 transition-transform duration-500">
              <img
                src="https://public.readdy.ai/ai/img_res/65e4c4613197f8df016256e2292b0934.jpg"
                alt="Luxe Botanica Campaign"
                className="w-full h-auto object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#00989e] text-white px-6 py-4 rounded-xl shadow-lg">
              <p className="text-3xl font-bold">340%</p>
              <p className="text-sm opacity-90">Follower Growth</p>
            </div>
          </div>

          <div
            ref={contentRef}
            className={`transition-all duration-1000 delay-200 ${
              contentVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'
            }`}
          >
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center">
                <i className="ri-leaf-line text-[#00989e] text-xl"></i>
              </div>
              <div>
                <h3 className="font-semibold text-slate-900">Luxe Botanica</h3>
                <p className="text-sm text-slate-500">Organic Skincare Brand</p>
              </div>
            </div>

            <h3 className="font-['Montserrat'] text-2xl md:text-3xl font-bold text-slate-900 mb-6">
              From Local Startup to National Recognition
            </h3>

            <blockquote className="text-lg text-slate-600 italic mb-8 pl-4 border-l-4 border-[#00989e]">
              &quot;Unuu didn&apos;t just grow our following—they helped us build a community of loyal customers 
              who genuinely love our brand. The results exceeded every expectation we had.&quot;
            </blockquote>

            <p className="text-slate-600 mb-8">
              When Luxe Botanica approached us, they had beautiful products but struggled to stand out 
              in the crowded skincare market. We developed a comprehensive content strategy focusing on 
              education, authenticity, and community engagement.
            </p>

            <div className="grid grid-cols-3 gap-6 mb-8">
              <div className="text-center p-4 bg-slate-50 rounded-xl">
                <p className="text-2xl font-bold text-slate-900">340%</p>
                <p className="text-sm text-slate-500">Follower Growth</p>
              </div>
              <div className="text-center p-4 bg-slate-50 rounded-xl">
                <p className="text-2xl font-bold text-slate-900">180%</p>
                <p className="text-sm text-slate-500">Engagement Rate</p>
              </div>
              <div className="text-center p-4 bg-slate-50 rounded-xl">
                <p className="text-2xl font-bold text-slate-900">250%</p>
                <p className="text-sm text-slate-500">Sales Increase</p>
              </div>
            </div>

            <button className="px-8 py-3.5 bg-slate-900 text-white font-semibold rounded-full hover:bg-slate-800 transition-colors cursor-pointer whitespace-nowrap">
              Read Full Case Study
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
